import React, { memo } from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../../common';
import { mediumMediaQuery, smallMediaQuery } from '../../../common/utilities/sizeHelpers';

interface BreakingNewsTitleProps {
    Title?: string;
}

const mapStoreStateToProps = (storeState: object) => {
    const { breakingNews } = storeState || {};
    const { Title } = breakingNews?.breakingNewsStory || {};

    return {
        Title
    };
};

const mapDispatchToProps = {};

export const BreakingNewsTitle = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ Title }: BreakingNewsTitleProps) => {
    return (
        <HeaderTitleContainer>
            <TitleContent>
                {Title}
            </TitleContent>
        </HeaderTitleContainer>
    );
}));

const HeaderTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: auto;
    font-family: 'Source Sans Pro Bold', sans-serif;
    font-size: 64px;
    color: #FFF;
    text-align: left;
    font-weight: 600;
    margin-top: 35px;
    margin-bottom: 50px;
    min-height: 112px;

    @media ${mediumMediaQuery} {
        font-size: 54px;
        margin-top: 32px;
        margin-bottom: 43px;
    }

    @media ${smallMediaQuery} {
        font-size: 26px;
        margin-top: 23px;
        margin-bottom: 11px;
    }
`;

const TitleContent = styled.div`
    width: 80%;
`;